import style from "./downloads.module.css";
import CopyBlock from "../Common/CopyBlock/CopyBlock";

import loggerScreenshot from "../../assets/LoggerScreenshot.png";
import emptyLoggerScreenshot from "../../assets/EmptyLoggerScreenshot.png";
import burpScreenshot1 from "../../assets/BurpScreenshot1.png";
import burpScreenshot2 from "../../assets/BurpScreenshot2.png";
import { Key } from "lucide-react";

function Downloads() {
  const command = "curl -sL https://raw.githubusercontent.com/Pentra-Solutions/rel_logger/main/install.sh | bash";

  return (
    <div className={style.downloadsWrapper}>
      <h3 className={style.title}>Logger Setup</h3>
      <div className={style.cardWrapper}>
        <p className={style.text}>
          To download and setup logger, <span className={style.blueText}>run in any bash terminal</span>:
        </p>
        <CopyBlock text={command} />
        <p className={style.text}>
          <br />
          In order to get a token, create a <span className={style.blueText}>New Pentest</span>, and it should appear at
          the top of the page.
          <br />
          <br />
          <p className={style.note}>
            <span className={style.blueText}>Note:</span> If you don't see any token, click on the{" "}
            <Key stroke="var(--light-blue-icon)" strokeWidth="1.5" className={style.inlineIcon}/>{" "}
            icon on the top of the Commmands list.
          </p>
          <br />
          <img alt={"Logger Screenshot"} className={style.screenshot + " " + style.screenshotBorder} src={emptyLoggerScreenshot} />
          <br />
          To start the logger, run <span className={style.blueText}>sudo pentra</span>, and it should
          tell you to supply a token.
          <br />
          <img alt={"Logger Screenshot"} className={style.screenshot} src={loggerScreenshot} />
          <br />
          <p className={style.note}>
            <span className={style.blueText}>Note:</span> The script automatically adds the executable to your /bin/
            folder, no need to restart the terminal.
          </p>
        </p>
      </div>

      <h3 className={style.title + " " + style.padding}>Burp Setup</h3>
      <div className={style.cardWrapper}>
        <p className={style.text}>
          To download the Pentra Burp Plugin, visit{" "}
          <a
            className={style.blueText + " " + style.link}
            href={
              "https://github.com/Pentra-Solutions/burp-integration/releases/download/v0.1/pentra-send-to-logger.py"
            }
          >
            our github page
          </a>
          .
        </p>
        <p className={style.text}>
          Besides the Pentra executable, you should also download jython from{" "}
          <a
            className={style.blueText + " " + style.link}
            href={"https://repo1.maven.org/maven2/org/python/jython-standalone/2.7.3/jython-standalone-2.7.3.jar"}
          >
            the official page
          </a>
          .
        </p>
        <p className={style.text}>
          <br />
          Afterwards, follow these steps to enable the plugin: <br />
          <br />
          1. Open Burp.
          <br />
          2. Go to{" "}
          <span className={style.blueText}>
            Settings {">"} Extensions {">"} Python Environment
          </span>
          .<br />
          3. Set the <span className={style.blueText}>Location of Jython standalone JAR file</span> to the downloaded
          jython file.
          <br />
          <img alt={"Burp Screenshot"} className={style.screenshot} src={burpScreenshot1} />
          4. Close Settings and go to <span className={style.blueText}>Extensions</span> tab.
          <br />
          5. Click <span className={style.blueText}>Add</span>, set <span className={style.blueText}>Python</span>{" "}
          extension type, and select the downloaded Pentra file as{" "}
          <span className={style.blueText}>Extension File</span>, then hit <span className={style.blueText}>Next</span>
          .<br />
          <img alt={"Burp Screenshot"} className={style.screenshot} src={burpScreenshot2} />
          <br />
          Afterwards, you can check whether the plugin functions by right-clicking on any intercepted command and
          selecting{" "}
          <span className={style.blueText}>
            Extensions {">"} Pentra {">"} Send to Pentra
          </span>
          .<br />
          <br />
          <p className={style.note}>
            <span className={style.blueText}>Note:</span> the command logger has to be running in the background for the
            burp commands to be intercepted.
          </p>
        </p>
      </div>
    </div>
  );
}

export default Downloads;
